const utils = require('frontend-controller/lib/utils')

module.exports = {
	config: {
		useAttributeForPicker: '',
	},

	model: {
		selectedPrimaryKeys: [], // list of actual selected primaryKeys
		selectedEntities: [], // list of selected entities according to this.model.selectedPrimaryKeys.
		selectedEntity: {}, // if this is a single element picker (this.config.isMultiSelect === false) then this is the first entry of selectedEntities which is a list in every case.
		isDisabled: false,
	},

	events: {
		click: function(event){
			event.preventDefault();
			event.stopImmediatePropagation();

			var self = event.data.component;
			var $target = $(event.target).closest('button');
			if($target.length > 0){
				var mode = $target.data('buttonMode');

				if(mode === 'empty'){
					self.empty();
				} else {
					utils.performButtonAction(event);
				}
			}
		}
	},

	methods: {

		prepare(){
			this.prepareMeta()
		},

		prepareMeta: function() {
			const fieldConfig = this.model.config || {}
			const formMapping = this.formMapping || {}

			this.model.isDisabled = Boolean((formMapping.fieldConfig || {}).disabled || fieldConfig.disabled)

			this.model.selectedPrimaryKeys = []
			if(this.model.dataJSON){
				if(utils.isArray(this.model.dataJSON)){
					this.model.selectedPrimaryKeys = this.model.dataJSON
				} else {
					this.model.selectedPrimaryKeys = [this.model.dataJSON]
				}
			}
		},

		getResourceFilters(storage, resourceFilters, actionKey){
			resourceFilters = resourceFilters || {}

			if(actionKey === 'mblx.prompts.get.picker') {
				resourceFilters.baseFilters = resourceFilters.baseFilters || {}
				resourceFilters.baseFilters.listOfPrimaryKeys = this.model.selectedPrimaryKeys || []
				resourceFilters.order = 'content'
			}

			return resourceFilters
		},

		loadResourcesGranted(storage, resourceFilters, actionKey, fieldCode, attachTriggerOptions){
			return actionKey !== 'mblx.prompts.get.picker' || utils.collectionSize(resourceFilters.baseFilters.listOfPrimaryKeys) > 0
		},

		async refreshFieldResources(){
			const fieldConfig = this.model.config || {}

			if(utils.collectionSize(this.model.selectedPrimaryKeys) > 0){
				const {
					action: {
						response: {
							data: selectedPromptsData = []
						}
					}
				} = await this.performAction('mblx.prompts.get.picker')

				this.model.selectedEntities = selectedPromptsData || []
				this.model.selectedEntity = {}

				if(!fieldConfig.isMultiSelect){
					this.model.selectedEntity = this.model.selectedEntities[Object.keys(this.model.selectedEntities)[0]] || {}
				}
			}
		},

		showSelect: function(baseActionKey, buttonContext, buttonMode, actionBossComponent, additionalData){
			if(this.model.isDisabled) return;

			var blackListedEntityIDs = [];
			this.closest('base_form_form', function(form){
				var attributeName = (form.resourceData.data || {}).primaryKey || 'id'
				if(this.config.useAttributeForPicker){
					attributeName = this.config.useAttributeForPicker
				}
				var entityID = ((form.resourceData.data || {}).attributes || {})[attributeName]
				if(entityID){
					blackListedEntityIDs.push(entityID);
				}
			});
			this.performAndStoreAction(
				'showSelect_prompts_inEffect',
				this.prepareAction(
					'mblx.prompts.showSelect',
					undefined,
					{
						selectedRowIDs: this.model.dataJSON || [],
						blackListedEntityIDs
					}
				)
			)
		},

		async close(){
			await this.destroyAction('showSelect_prompts_inEffect')
		},

		empty(){
			if(this.model.isDisabled) return;

			this.model.dataJSON = null
			this.model.selectedPrimaryKeys = []
			this.model.selectedEntities = []
			this.model.selectedEntity = {}

			let parent
			this.parent(p => parent = p)
			if(parent){
				parent.fieldToModel(this.model.fieldCode, this.model.dataJSON);
				this.refresh();
			}
		},

		/**
		 * checks if the actual selected field is the one which has been loaded
		 * aka should the picker load the data of the selected element.
		 *
		 * @returns {boolean}
		 */
		fieldResourcesMatchSelection(){
			let selection = this.model.dataJSON || []
			if(!utils.isArray(selection)){
				selection = [selection]
			}

			for(const selectedPrimaryKey of Object.values(selection)){
				let selectionFound = false

				for(const {
					attributes: {
						promptID,
						id
					} = {}
				} of Object.values(this.model.selectedEntities)){
					if(
						(id && selectedPrimaryKey == id) ||
						(promptID && selectedPrimaryKey == promptID)
					){
						selectionFound = true
						break
					}
				}

				if(!selectionFound){
					return false
				}
			}

			return true
		}
	},

	hooks: {
		async attach($element, options){
			// since there is no elegant solution to load these data earlier at the moment it has to be done here.
			if(!options.refresh && utils.collectionSize(this.model.selectedPrimaryKeys) > 0 && !this.fieldResourcesMatchSelection()){
				await this.refreshFieldResources()
				await this.refresh()
			}
		},

		async onDecision($element, options){
			const fieldConfig = this.model.config || {}

			switch(options.decisionType){
				case 'submit':
					this.model.dataJSON = this.model.dataJSON || null

					let table, parent
					options.decisionComponent.find('templates_mblx_prompts_table_table', c => table = c)
					this.parent(c => parent = c)

					if(!table) break;
					if(options.decisionOptions.mode !== 'useSelection') break;

					let fieldValue	= table.getSelectedRowIDs(true) || {}
					this.model.selectedPrimaryKeys = fieldValue
					this.model.selectedEntities = table.getSelectedRows(true) || []
					this.model.selectedEntity 	= {}

					if(!fieldConfig.isMultiSelect) {
						fieldValue = fieldValue[0]
						this.model.selectedEntity = (this.model.selectedEntities || [])[Object.keys(this.model.selectedEntities)[0]] || {}
					}

					this.model.dataJSON = fieldValue

					if(!parent) break;

					await this.close()
					parent.fieldToModel(this.model.fieldCode, fieldValue)
					await this.refresh(false)
					break;

				case 'cancel':
					// do nothing
					break;
			}

			options.decisionComponent.hide();
		},

		onChildChanged: function($element, options){
			this.triggerClosest('onChildChanged', {
				fieldCode: this.model.fieldCode,
				value: options.value
			});
		}
	}
};